import { gql } from '@apollo/client';

export default gql`
  mutation DeleteThread($courseId: String!, $threadId: String!) {
    deleteThread(courseId: $courseId, threadId: $threadId)
      @rest(
        type: "Thread"
        path: "courses/{args.courseId}/threads/{args.threadId}"
        method: "DELETE"
      ) {
      _id
    }
  }
`;
